import { RouterModule, Routes } from '@angular/router'

// Import components
import { ChildrenListComponent } from './ChildrenListComponent'

const ChildrenListRoutes : Routes = [
    {
        path: 'booking/students',
        component: ChildrenListComponent
    }
];

export const ChildrenListRouter = RouterModule.forChild(ChildrenListRoutes);


// WEBPACK FOOTER //
// ./src/bus/parent/children-list/ChildrenListRouting.ts